import React from "react";

import logo from "assets/images/logo.svg";

const Logo = () => {
	return <img src={logo} alt='Rawyy' style={{ width: "50px" }} />;
};

export default Logo;
